import GenerateEnum from '../generateEnum'
import { getLabelText } from '../utils.js'

export const effectiveStatusList = [
  { label: '一直生效', value: 1000 },
  { label: '本土vat有效', value: 1010 },
  { label: '本土vat无效', value: 1020 }
]

/*
UNAUTHORIZED("0", "未授权"),
    AUTHORIZING("1", "授权中"),
	FROZEN("2", "已冻结"),
    CANCELED("3", "已注销"),
    AUTHORIZED("4", "已授权"),
    TO_BE_RENEWED("5", "待续费"),
    CANCELING("6", "注销中"),
	TAX_CHECKING("7", "查税中"),
    REVOKED("8", "已撤销"),
	UNPAID("9", "未付费"),
	DERECOGNITION_IN_CONFIRM("10", "终止确认中"),
    DERECOGNITION_IN_PROGRESS("11", "终止中"),
    TERMINATED("12", "已终止")*/
export const taxStatusEnum = GenerateEnum({
  UNAUTHORIZED: {
    label: '未授权',
    value: '0'
  },
  AUTHORIZING: {
    label: '授权中',
    value: '1'
  },
  FROZEN: {
    label: '已冻结',
    value: '2'
  },
  CANCELED: {
    label: '已注销',
    value: '3'
  },
  AUTHORIZED: {
    label: '已授权',
    value: '4'
  },
  TO_BE_RENEWED: {
    label: '待续费',
    value: '5'
  },
  CANCELING: {
    label: '注销中',
    value: '6'
  },
  TAX_CHECKING: {
    label: '查税中',
    value: '7'
  },
  REVOKED: {
    label: '已撤销',
    value: '8'
  },
  UNPAID: {
    label: '未付费',
    value: '9'
  },
  DERECOGNITION_IN_CONFIRM: {
    label: '终止确认中',
    value: '10'
  },
  DERECOGNITION_IN_PROGRESS: {
    label: '终止中',
    value: '11'
  },
  TERMINATED: {
    label: '已终止',
    value: '12'
  },
})



// WEBPACK FOOTER //
// /data/.jenkins/workspace/ost-prod/@ost/lib/enum/taxRate.js